import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useEffect, useMemo } from "react";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { ReadStatusE } from "../../../zustand/configSlice";
import { useStore } from "../../../zustand/store";

interface IFormInputs {
	readStatus: ReadStatusE;
	searchTerm: string;
}

export const FilterBar = () => {
	const { t } = useTranslation();
	const setReadFilter = useStore((state) => state.setReadFilter);
	const defaultReadFilter = useStore((state) => state.journalReadFilter);
	const defaultValues = useMemo(
		() => ({
			readStatus: defaultReadFilter,
			searchTerm: ""
		}),
		[defaultReadFilter]
	);

	const { control, watch } = useForm<IFormInputs>({
		defaultValues
	});

	useEffect(() => {
		const subscription = watch((value) => {
			if (value.readStatus !== undefined) setReadFilter(value.readStatus);
		});

		return () => {
			subscription.unsubscribe();
		};
	}, [watch, setReadFilter]);

	return (
		<form>
			<Controller
				render={({ field }) => (
					<ToggleButtonGroup exclusive {...field}>
						<ToggleButton color="primary" value={ReadStatusE.All} sx={{ minWidth: "100px" }}>
							{t("IDS_JOURNAL_FILTER_ALL")}
						</ToggleButton>
						<ToggleButton value={ReadStatusE.Unread} sx={{ minWidth: "100px" }}>
							{t("IDS_JOURNAL_FILTER_UNREAD")}
						</ToggleButton>
					</ToggleButtonGroup>
				)}
				name="readStatus"
				control={control}
			/>
		</form>
	);
};
